const push = async (eventName: string, data: any) => {
  if (process.client) {
    data.event = eventName;
    window.dataLayer?.push(data);
  }
};

export default { push };
